import React from 'react'
import { useHistory } from 'react-router-dom';
import { Laptop, Bot, SquareArrowUpRight, HelpCircle } from 'lucide-react'

export default function QuickStart({ project }) {
    const history = useHistory();
    const discoveryCards = [
        {
            title: 'Introduction',
            description: 'Learn about QodexAI and how it can help you test your APIs.',
            icon: Laptop,
            link: "https://docs.qodex.ai/introduction"
        },
        {
            title: 'AI Agent',
            description: 'Read how to create test scenarios with AI using your API collection.',
            icon: Bot,
            link: "https://docs.qodex.ai/creating-test-scenarios-with-ai"
        },
        {
            title: 'Having Issues?',
            description: 'Book a demo and understand the product.',
            icon: HelpCircle,
            link: "https://cal.com/siddhant-mohan/45mins"
        },

    ]

    return (
        <div className="max-w-4xl mx-auto px-4 md:px-8 py-6">
            <p className='fs24 font-semibold mb-0'>Setup Your Project</p>
            <div className='w-full flex flex-col mb-6'>
                {/* <div className='w-full flex items-center justify-between py-4' style={{ borderBottom: "1px solid var(--borderColor)" }}>
                    <div>
                        <h2 className="fs15 font-normal mb-0">Demo Mode</h2>
                        <p className='fs13 textSecondary mb-0'>Having doubts on how to use the platform? Check out our demo mode.</p>
                    </div>
                    <button
                        onClick={() => history.push('/demo')}
                        className={`w-32 px-6 py-1 mt-1 rounded-1 font-medium text-[var(--text-primary)] transition-colors fs12 disabled:cursor-not-allowed disabled:opacity-50 bgSecondary hoverBg customBorder`}
                    >
                        Explore
                    </button>
                </div> */}

                <div className='w-full flex items-center justify-between py-4' style={{ borderBottom: "1px solid var(--borderColor)" }}>
                    <div>
                        <h2 className="fs15 font-normal mb-0">Try with a single API</h2>
                        <p className='fs13 textSecondary mb-0'>Don't have an API Collection? Don't worry, get started with our demo API.</p>
                    </div>
                    <button
                        onClick={() => history.push('/collections')}
                        className={`w-32 px-6 py-1 mt-1 rounded-1 font-medium text-[var(--text-primary)] transition-colors fs12 disabled:cursor-not-allowed disabled:opacity-50 bgSecondary hoverBg customBorder`}
                    >
                        Try Now
                    </button>
                </div>

                <div className='w-full flex items-center justify-between py-4' style={{ borderBottom: "1px solid var(--borderColor)" }}>
                    <div>
                        <h2 className="fs15 font-normal mb-0">Import Collection & Generate Tests</h2>
                        <p className='fs13 textSecondary mb-0'>If you have an API Collection, you can import it and create tests for it.</p>
                    </div>
                    <button
                        onClick={() => history.push('/ai-agent?newChat=true')}
                        className={`w-32 px-6 py-1 mt-1 rounded-1 font-medium text-[var(--text-primary)] transition-colors fs12 disabled:cursor-not-allowed disabled:opacity-50 bgSecondary hoverBg customBorder`}
                    >
                        Import
                    </button>
                </div>

                <div className='w-full flex items-center justify-between py-4' style={{ borderBottom: "1px solid var(--borderColor)" }}>
                    <div>
                        <h2 className="fs15 font-normal mb-0">Looking for Product and Website Monitoring?</h2>
                        <p className='fs13 textSecondary mb-0'>Sign up on Uptime Monitoring to monitor your product and website.</p>
                    </div>
                    <button
                        onClick={() => window.open('https://uptime.qodex.ai/signup?utm_source=app.qodex.ai', '_blank', 'noopener,noreferrer')}
                        className={`w-32 px-6 py-1 mt-1 rounded-1 font-medium text-[var(--text-primary)] transition-colors fs12 disabled:cursor-not-allowed disabled:opacity-50 bgSecondary hoverBg customBorder`}
                    >
                        Sign Up
                    </button>
                </div>
            </div>
            <div className="flex items-center justify-between mb-4">
                <h2 className="fs24 font-semibold">Discover what you can do in QodexAI</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {discoveryCards.map((card, index) => {
                    const Icon = card.icon
                    const isLink = Boolean(card.link)
                    return (
                        <div
                            key={index}
                            role={isLink ? 'button' : undefined}
                            tabIndex={isLink ? 0 : -1}
                            onClick={() => {
                                if (card.link) window.open(card.link, '_blank', 'noopener,noreferrer')
                            }}
                            onKeyDown={(e) => {
                                if (!isLink) return
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault()
                                    window.open(card.link, '_blank', 'noopener,noreferrer')
                                }
                            }}
                            className={`group relative rounded-xl border p-3 transition-colors ${isLink ? 'cursor-pointer hover:border-[var(--borderColor)]' : ''
                                }`}
                        >
                            <div className="w-12 h-12 rounded-lg grid place-items-center mb-3 bgBrand text-white">
                                <Icon size={22} />
                            </div>
                            <div className="fs14 font-normal mb-1 pr-6">{card.title}</div>
                            <div className="fs12 textSecondary mb-0 pr-8">{card.description}</div>

                            {/* Hover chevron */}
                            {isLink && (
                                <div className="pointer-events-none absolute top-3 right-3 z-10 textBrand opacity-0 group-hover:!opacity-100 group-hover:translate-x-1 transition-all duration-200 ease-out">
                                    <SquareArrowUpRight size={18} />
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
